import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import PaymentIcons from './PaymentIcons';

const footerCols = [
  {
    title: 'Help',
    links: [
      { label: 'Track Your Order', href: '/pages/track-your-order' },
      { label: 'Contact', href: '/pages/contact' },
    ],
  },
  {
    title: 'About',
    links: [
      { label: 'Our Story', href: '/pages/our-story' },
      { label: 'Ingredients', href: '/pages/ingredients' },
    ],
  },
  {
    title: 'Shop',
    links: [
      { label: 'Korean Scalp Revival Bar', href: '/products/korean-scalp-revival-bar' },
    ],
  },
];

const policyLinks = [
  { label: 'Privacy policy', href: '/policies/privacy-policy' },
  { label: 'Refund policy', href: '/policies/refund-policy' },
  { label: 'Terms of service', href: '/policies/terms-of-service' },
  { label: 'Shipping policy', href: '/policies/shipping-policy' },
  { label: 'Contact information', href: '/policies/contact-information' },
];

const Footer = () => {
  const [openCol, setOpenCol] = useState(null);

  return (
    <footer style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex flex-col leading-none">
              <span
                className="font-serif text-[40px] italic"
                style={{ color: '#F5EDDF' }}
              >
                K-Root
              </span>
              <span className="text-[10px] tracking-[0.18em] uppercase opacity-80 mt-1">
                Less shedding. More hair.
              </span>
            </Link>
            <p className="mt-5 text-[13px] leading-relaxed opacity-85 max-w-[320px]">
              Centuries of Korean botanical wisdom — distilled into a single ritual bar for the modern scalp.
            </p>
          </div>

          {/* Columns desktop */}
          <div className="hidden md:grid md:col-span-8 grid-cols-3 gap-8">
            {footerCols.map((col) => (
              <div key={col.title}>
                <h4 className="text-[13px] uppercase tracking-[0.16em] opacity-80 mb-4">
                  {col.title}
                </h4>
                <ul className="space-y-2">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.href} className="text-[14px] hover:underline opacity-95">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile accordion */}
        <div className="md:hidden mt-10 divide-y" style={{ borderColor: 'rgba(245,237,223,0.2)' }}>
          {footerCols.map((col, idx) => (
            <div key={col.title} className="py-3" style={{ borderColor: 'rgba(245,237,223,0.2)' }}>
              <button
                onClick={() => setOpenCol(openCol === idx ? null : idx)}
                className="flex w-full items-center justify-between text-[14px]"
              >
                <span>{col.title}</span>
                <ChevronDown
                  size={16}
                  className={`transition-transform ${openCol === idx ? 'rotate-180' : ''}`}
                />
              </button>
              {openCol === idx && (
                <ul className="mt-3 space-y-2 pb-2">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link to={l.href} className="text-[13px] opacity-90">
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* Policy row */}
        <div className="mt-12 pt-6 border-t flex flex-col md:flex-row gap-4 md:items-center md:justify-between"
          style={{ borderColor: 'rgba(245,237,223,0.15)' }}>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-[12px] opacity-90">
            {policyLinks.map((l) => (
              <Link key={l.label} to={l.href} className="underline-offset-4 hover:underline">
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Payments + copyright */}
        <div className="mt-6 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <div className="rounded-xl px-4 py-3 inline-flex" style={{ backgroundColor: '#F5EDDF' }}>
            <PaymentIcons />
          </div>
          <p className="text-[12px] opacity-80">© 2026 K-Root</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
